import React from 'react';
import EducationServicesImage from '../../../assets/images/home_screen/education_services.webp';
import GradientOutlineButton from '../../../components/atoms/GradientOutlineButton';
import { motion } from 'framer-motion';

const Content = () => {
  return (
    <section className="relative w-full flex items-center justify-center lg:px-4 py-10 md:py-20">
      <div className="relative w-full max-w-[1200px] px-4 md:px-10 py-8 md:py-10 flex flex-col md:flex-row items-center md:items-start md:text-left gap-10 bg-[#EBF2FA]">
        <div className="absolute hidden md:block -left-[1000px] w-[1500px] bg-[#EBF2FA] h-full top-0 z-0"></div>
        <div className="flex-1 z-10">
          <h2 className="text-4xl md:text-5xl font-bold text-primary leading-tight">
            Educational <br /> Services
          </h2>
          <p className="text-secondary text-lg mt-4">
            At Guidepost Educational Services, we tailor educational support to
            meet each child's unique needs, from struggling readers and math
            learners to dyslexic and gifted students. Our specialists provide
            individualized plans, dynamic assessments, and innovative teaching
            to turn challenges into growth opportunities. Discover how we can
            partner to unlock your child's potential.
          </p>
          <div className="mt-6">
            <GradientOutlineButton
              text="Educational Services"
              isDark={false}
              navigateTo={'/services/educational-service'}
            />
          </div>
        </div>
        <div className="flex-1 flex justify-center z-10">
          <img
            src={EducationServicesImage}
            alt="Smiling children and therapist at Guidepost Educational Services with assistive walker support"
            className="w-[320px] md:h-[400px] rounded-lg"
          />
        </div>
      </div>
    </section>
  );
};

const EducationServices = () => {
  return (
    <>
      <motion.h1
        initial={{ opacity: 0, x: -500 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 1, ease: 'easeOut' }}
        viewport={{ once: true, amount: 0.5 }}
        className="hidden md:block"
      >
        <Content />
      </motion.h1>
      <div className="block md:hidden">
        <Content />
      </div>
    </>
  );
};

export default EducationServices;
